'use client';

import { Text, useCss } from '@nettbureau/vibrant-ui';
import { useContext } from 'react';
import { ConfigContext } from '../provider/config-provider';
import { getTheme, getTokenFromVibrant } from '../theme';

interface ContainerTitleProps {
  title: string;
  alignment: 'center' | 'left' | 'right';
}

export function ContainerTitle({ title, alignment }: ContainerTitleProps) {
  const { globalThemeVariant, theme } = useContext(ConfigContext);

  const titleStyles = useCss((input) => {
    return {
      color: getTokenFromVibrant(
        globalThemeVariant === 'default'
          ? getTheme(theme).default.heading.textColor
          : globalThemeVariant === 'secondary'
            ? getTheme(theme).secondary.heading.textColor
            : getTheme(theme).districtPicker.heading.textColor,
        input.theme,
      ),
    };
  });

  return (
    <Text
      weight="medium"
      data-featured-title
      size="3xl"
      align={alignment}
      css={titleStyles}
    >
      {title}
    </Text>
  );
}
